/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * The member on a path.
 */
export interface NetworkMemberRef {
  id: string;
  name: string;
  user_id?: string | null;
  can_request_intro: boolean;
}
